import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const Vacancy = Loadable({
  loader: () => import("./Vacancy"),
  loading: Loading
})
